import { render, staticRenderFns } from "./AccountContactUsRequests.vue?vue&type=template&id=316f2b52&"
import script from "./AccountContactUsRequests.vue?vue&type=script&lang=js&"
export * from "./AccountContactUsRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports